module.exports = __webpack_public_path__ + "img/THY.556dafac.png";